import React, { useEffect, useRef, useState } from 'react';
import styles from './../addCategoryForm/addCategoryForm.module.css';
import { Close, Closecircle, closeCircle, UploadImg } from '../../Svg';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { Country, State } from "country-state-city";
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

import { addVendorThunk, editVendorThunk } from '../../redux/vendor/vendorSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import stylesp from './prod.module.css';

const EditVendorForm = () => {

    const { admin } = useSelector((state) => state?.admin)
    const [isOpen, setIsOpen] = useState(false);

    const { exportedData } = useSelector((state) => state.manufacturer);
    const { editvendor } = useSelector((state) => state.vendor);
    const { loading, vendorDetails, refresh, statusLoading } = useSelector((state) => state.vendor);

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [countries, setCountries] = useState([]);

    const [billingStates, setBillingStates] = useState([]);
    const [shippingStates, setShippingStates] = useState([]);

    const [isPasswordVisible, setPasswordVisible] = useState(false)
    const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false)
   const [filteredData, setFilteredData] = useState(null);


    const [searchTerm, setSearchTerm] = useState('');
       const dropdownRef = useRef(null);
   
       useEffect(() => {
           const handleClickOutside = (event) => {
               if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                   closeDropdown();
               }
           };
   
           document.addEventListener('mousedown', handleClickOutside);
           return () => {
               document.removeEventListener('mousedown', handleClickOutside);
           };
       }, []);
   
       const closeDropdown = () => {
           setIsOpen(false);
           setSearchTerm('');
           setFilteredData(null);
       };
   
       const handleToggleDropdown = () => {
           const newState = !isOpen;
           setIsOpen(newState);
           if (!newState) {
               closeDropdown();
           }
       };
   
       const handleSearchChange = (e) => {
           const term = e.target.value;
           setSearchTerm(term);
           const filtered = term === ''
               ? null
               : exportedData?.data?.filter(customer =>
                   customer?.name?.toLowerCase().includes(term.toLowerCase())
               );
           setFilteredData(filtered);
       };
   

    // Fetch countries on component mount
    useEffect(() => {
        const countryList = Country.getAllCountries();
        setCountries(countryList);

    }, []);





    const {
        errors,
        values,
        handleChange,
        touched,
        setFieldValue,
        isSubmitting,
        handleBlur,
        handleSubmit,
        resetForm
    } = useFormik({
        initialValues: {
            fullName: vendorDetails?.fullName || "",
            phone: vendorDetails?.phone || "",
            email: vendorDetails?.email || "",
            companyName: vendorDetails?.companyName || "",
            gstn: vendorDetails?.gstn || "",
            password: vendorDetails?.password || "",
            confirmPassword: vendorDetails?.password || "",
            billingAddress: vendorDetails?.billingAddress || [{
                factoryUnits: "",
                streetAddress: "",
                country: "",
                state: "",
                zipCode: "",
            }],
            shippingAddress: vendorDetails?.shippingAddress || [{
                factoryUnits: "",
                streetAddress: "",
                country: "",
                state: "",
                zipCode: "",
            }],
            activeStatus: vendorDetails?.activeStatus || "",
            category: {
                status: vendorDetails?.category?.status || ""
            },
            admin: vendorDetails?.admin || "",
            status: "APPROVED",
            // manufacturers: vendorDetails?.manufacturers || []
            manufacturers: vendorDetails?.manufacturers?.map(m => m?._id) || []


        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            fullName: Yup.string().required('Name is required'),
            phone: Yup.string().required('Phone number is required'),
            email: Yup.string().email('Invalid email').required('Email is required'),
            companyName: Yup.string().required('Company name is required'),
            gstn: Yup.string().required('GSTN number is required'),
            password: Yup.string().required('Password is required'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required('Confirm password is required'),
            billingAddress: Yup.array().of(
                Yup.object().shape({
                    factoryUnits: Yup.string().required("Required"),
                    streetAddress: Yup.string().required("Required"),
                    country: Yup.string().required("Required"),
                    state: Yup.string().required("Required"),
                    zipCode: Yup.string().required("Required"),
                })
            ),
            shippingAddress: Yup.array().of(
                Yup.object().shape({
                    factoryUnits: Yup.string().required("Required"),
                    streetAddress: Yup.string().required("Required"),
                    country: Yup.string().required("Required"),
                    state: Yup.string().required("Required"),
                    zipCode: Yup.string().required("Required"),
                })
            ),

            activeStatus: Yup.string().required('status is required'),
            admin: Yup.string().required('Admin is required')

        }),

        onSubmit: async (values) => {
            const data = {
                id: vendorDetails?._id,
                values
            }
            const status = await dispatch(editVendorThunk(data))

            if (status.payload === 200) {
                navigate(-1)
            }
        },
    });


    console.log(values.manufacturers);
    console.log(exportedData);
    console.log(vendorDetails);
    
    


    const handleCountryChange = (type, index, value) => {
        const selectedCountry = countries.find((country) => country.name === value);
        if (selectedCountry) {
            const states = State.getStatesOfCountry(selectedCountry.isoCode);

            if (type === "billingAddress") {
                const updatedStates = [...billingStates];
                updatedStates[index] = states;
                setBillingStates(updatedStates);
            } else if (type === "shippingAddress") {
                const updatedStates = [...shippingStates];
                updatedStates[index] = states;
                setShippingStates(updatedStates);
            }
        }

        setFieldValue(`${type}[${index}].country`, value);
        setFieldValue(`${type}[${index}].state`, ""); // Reset state
    };





    useEffect(() => {
        values.billingAddress?.forEach((address, index) => {
            if (address.country) {
                const selectedCountry = countries.find(
                    (country) => country.name === address.country
                );
                if (selectedCountry) {
                    const states = State.getStatesOfCountry(selectedCountry.isoCode);
                    setBillingStates((prevStates) => {
                        const updatedStates = [...prevStates];
                        updatedStates[index] = states;
                        return updatedStates;
                    });
                }
            }
        });

        // Initialize states for shipping addresses
        values.shippingAddress?.forEach((address, index) => {
            if (address.country) {
                const selectedCountry = countries.find(
                    (country) => country.name === address.country
                );
                if (selectedCountry) {
                    const states = State.getStatesOfCountry(selectedCountry.isoCode);
                    setShippingStates((prevStates) => {
                        const updatedStates = [...prevStates];
                        updatedStates[index] = states;
                        return updatedStates;
                    });
                }
            }
        });
    }, [values.billingAddress, values.shippingAddress, countries]);



    // Handle selection change (Add or remove manufacturer)
    const handleSelectionChange = (manufacturerId) => {
        const { manufacturers } = values;
        if (manufacturers?.includes(manufacturerId)) {
            setFieldValue(
                "manufacturers",
                manufacturers?.filter(id => id !== manufacturerId)
            );
        } else {
            setFieldValue(
                "manufacturers",
                [...manufacturers, manufacturerId]
            );
        }
    };



    // console.log(values);
    
    return (
        <>
            <form onSubmit={handleSubmit} className={styles.updateCategoryContainer} >
                <div className={styles.genaralInfo}>
                    <div className={styles.formSection}>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>General Information</h2>

                            <label className={styles.addCatLabel}>
                                Full name
                                <input
                                    type="text"
                                    name="fullName"
                                    placeholder="Full name"
                                    className={styles.addCatInput}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.fullName}
                                />
                                {touched.fullName && errors.fullName ? (
                                    <div className={styles.errorText}>{errors.fullName}</div>
                                ) : null}
                            </label>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Phone number
                                    <input
                                        type="phone"
                                        name="phone"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.phone}
                                    />
                                    {touched.phone && errors.phone ? (
                                        <div className={styles.errorText}>{errors.phone}</div>
                                    ) : null}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Email id
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.email}
                                    />
                                    {touched.email && errors.email ? (
                                        <div className={styles.errorText}>{errors.email}</div>
                                    ) : null}
                                </label>
                            </div>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Company name
                                    <input
                                        type="text"
                                        name="companyName"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.companyName}
                                    />
                                    {touched.companyName && errors.companyName ? (
                                        <div className={styles.errorText}>{errors.companyName}</div>
                                    ) : null}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    GSTN number
                                    <input
                                        type="text"
                                        name="gstn"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.gstn}
                                    />
                                    {touched.gstn && errors.gstn ? (
                                        <div className={styles.errorText}>{errors.gstn}</div>
                                    ) : null}
                                </label>
                            </div>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Password
                                    <div className={styles.logininputContainer}>
                                        <input
                                            type={isPasswordVisible ? "text" : "password"}
                                            name="password"
                                            placeholder="********"
                                            className={styles.addCatInput}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.password}
                                        />
                                        <FontAwesomeIcon
                                            onClick={() => setPasswordVisible(!isPasswordVisible)}
                                            icon={isPasswordVisible ? faEyeSlash : faEye}
                                            className={styles.loginpasswordIcon}
                                        />
                                    </div>
                                    {touched.password && errors.password ? (
                                        <div className={styles.errorText}>{errors.password}</div>
                                    ) : null}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Confirm password
                                    <div className={styles.logininputContainer}>
                                        <input
                                            type={isConfirmPasswordVisible ? "text" : "password"}
                                            name="confirmPassword"
                                            placeholder="********"
                                            className={styles.addCatInput}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.confirmPassword}
                                        />
                                        <FontAwesomeIcon
                                            icon={isConfirmPasswordVisible ? faEyeSlash : faEye}

                                            className={styles.loginpasswordIcon}
                                            onClick={() => setConfirmPasswordVisible(!isConfirmPasswordVisible)}

                                        />
                                    </div>
                                    {touched.confirmPassword && errors.confirmPassword ? (
                                        <div className={styles.errorText}>{errors.confirmPassword}</div>
                                    ) : null}
                                </label>
                            </div>



                        </div>

                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>Billing address</h2>
                            {values?.billingAddress?.map((i, index) => (
                                <>
                                    <div style={{ display: 'flex', gap: '14px' }}>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            Factory Units
                                            <select
                                                className={styles.addCatSelect}
                                                name={`billingAddress[${index}].factoryUnits`}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={i?.factoryUnits}
                                            >
                                                <option value="">Select</option>
                                                <option value="Unit 1">Unit 1</option>
                                                <option value="Unit 2">Unit 2</option>
                                            </select>

                                            {touched.billingAddress?.[index]?.factoryUnits &&
                                                errors.billingAddress?.[index]?.factoryUnits && (
                                                    <div className={styles.errorText}>
                                                        {errors.billingAddress[index].factoryUnits}
                                                    </div>
                                                )}


                                        </label>
                                        <label className={styles.addCatLabel} style={{ width: '67%' }}>
                                            Street, area, city
                                            <input
                                                type="text"
                                                name={`billingAddress[${index}].streetAddress`}
                                                placeholder="Enter street address"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={i?.streetAddress}
                                                className={styles.addCatInput}
                                            />
                                            {touched.billingAddress?.[index]?.streetAddress &&
                                                errors.billingAddress?.[index]?.streetAddress && (
                                                    <div className={styles.errorText}>
                                                        {errors.billingAddress[index].streetAddress}
                                                    </div>
                                                )}
                                        </label>

                                    </div>
                                    <div style={{ display: 'flex', gap: '14px' }}>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            Country
                                            <select
                                                className={styles.addCatSelect}
                                                name={`billingAddress[${index}].country`}
                                                value={i.country}
                                                onChange={(e) =>
                                                    handleCountryChange("billingAddress", index, e.target.value)
                                                }
                                                onBlur={handleBlur}
                                            >
                                                <option value="">Select</option>{countries.map((country) => (
                                                    <option key={country.isoCode} value={country.name}>
                                                        {country.name}
                                                    </option>
                                                ))}

                                            </select>
                                            {touched.billingAddress?.[index]?.country &&
                                                errors.billingAddress?.[index]?.country && (
                                                    <div className={styles.errorText}>
                                                        {errors.billingAddress[index].country}
                                                    </div>
                                                )}
                                        </label>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            State
                                            <select
                                                className={styles.addCatSelect}
                                                name={`billingAddress[${index}].state`}
                                                value={i?.state}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            >
                                                <option value="">Select</option>
                                                {billingStates[index]?.map((state) => (
                                                    <option key={state.isoCode} value={state.name}>
                                                        {state.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {touched.billingAddress?.[index]?.state &&
                                                errors.billingAddress?.[index]?.state && (
                                                    <div className={styles.errorText}>
                                                        {errors.billingAddress[index].state}
                                                    </div>
                                                )}
                                        </label>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            Zip code
                                            <input
                                                type="text"
                                                name={`billingAddress[${index}].zipCode`}
                                                placeholder="Enter Zip code"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={i?.zipCode}
                                                className={styles.addCatInput}
                                            />
                                            {touched.billingAddress?.[index]?.zipCode &&
                                                errors.billingAddress?.[index]?.zipCode && (
                                                    <div className={styles.errorText}>
                                                        {errors.billingAddress[index].zipCode}
                                                    </div>
                                                )}
                                        </label>
                                    </div>
                                </>
                            ))}
                        </div>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>Shipping address</h2>
                            {values?.shippingAddress?.map((i, index) => (

                                <>
                                    <div style={{ display: 'flex', gap: '14px' }}>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            Factory Units
                                            <select
                                                className={styles.addCatSelect}
                                                name={`shippingAddress[${index}].factoryUnits`}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={i?.factoryUnits}
                                            >
                                                <option value="">Select</option>
                                                <option value="Unit 1">Unit 1</option>
                                                <option value="Unit 2">Unit 2</option>
                                            </select>
                                            {touched.shippingAddress?.[index]?.factoryUnits &&
                                                errors.shippingAddress?.[index]?.factoryUnits && (
                                                    <div className={styles.errorText}>
                                                        {errors.shippingAddress[index].factoryUnits}
                                                    </div>
                                                )}
                                        </label>
                                        <label className={styles.addCatLabel} style={{ width: '67%' }}>
                                            Street, area, city
                                            <input
                                                type="text"
                                                name={`shippingAddress[${index}].streetAddress`}
                                                placeholder="Enter street address"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={i?.streetAddress}
                                                className={styles.addCatInput}
                                            />
                                            {touched.shippingAddress?.[index]?.streetAddress &&
                                                errors.shippingAddress?.[index]?.streetAddress && (
                                                    <div className={styles.errorText}>
                                                        {errors.shippingAddress[index].streetAddress}
                                                    </div>
                                                )}
                                        </label>

                                    </div>
                                    <div style={{ display: 'flex', gap: '14px' }}>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            Country
                                            <select
                                                className={styles.addCatSelect}
                                                name={`shippingAddress[${index}].country`}
                                                value={i.country}
                                                onChange={(e) =>
                                                    handleCountryChange("shippingAddress", index, e.target.value)
                                                }
                                                onBlur={handleBlur}
                                            >
                                                <option value="">Select</option>
                                                {countries.map((country) => (
                                                    <option key={country.isoCode} value={country.name}>
                                                        {country.name}
                                                    </option>
                                                ))}

                                            </select>
                                            {touched.shippingAddress?.[index]?.country &&
                                                errors.shippingAddress?.[index]?.country && (
                                                    <div className={styles.errorText}>
                                                        {errors.shippingAddress[index].country}
                                                    </div>
                                                )}
                                        </label>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            State
                                            <select
                                                className={styles.addCatSelect}
                                                name={`shippingAddress[${index}].state`}
                                                value={i?.state}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            >
                                                <option value="">Select</option>
                                                {shippingStates[index]?.map((state) => (
                                                    <option key={state.isoCode} value={state.name}>
                                                        {state.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {touched.shippingAddress?.[index]?.state &&
                                                errors.shippingAddress?.[index]?.state && (
                                                    <div className={styles.errorText}>
                                                        {errors.shippingAddress[index].state}
                                                    </div>
                                                )}
                                        </label>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            Zip code
                                            <input
                                                type="text"
                                                name={`shippingAddress[${index}].zipCode`}
                                                placeholder="Enter Zip code"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={i?.zipCode}
                                                className={styles.addCatInput}
                                            />
                                            {touched.shippingAddress?.[index]?.zipCode &&
                                                errors.shippingAddress?.[index]?.zipCode && (
                                                    <div className={styles.errorText}>
                                                        {errors.shippingAddress[index].zipCode}
                                                    </div>
                                                )}
                                        </label>
                                    </div>
                                </>
                            ))
                            }
                        </div>
                    </div>
                    <div className={styles.buttonGroup}>
                        <button type="button" className={styles.cancelButton} onClick={() => resetForm()}><Close />Cancel</button>
                        <button type="submit" className={styles.updateButton} disabled={isSubmitting}>{isSubmitting ? 'please wait' : "Edit Vendor"}</button>
                    </div>
                </div>

                <div className={styles.thumbnain}>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}> Status</h2>
                        <label style={{ paddingBottom: '10px', display: "block" }}>
                            Status
                            <select
                                name="activeStatus"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.activeStatus}
                            >
                                <option value="">Select...</option>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">Inactive</option>
                            </select>
                            {touched.activeStatus && errors.activeStatus && (
                                <div className={styles.errorText}>{errors.activeStatus}</div>
                            )}
                        </label>
                    </div>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>Manufacturer </h2>
                        <div style={{ paddingBottom: '10px', display: "block", marginTop: 10 }} className={styles.addCatLabel}>
                            Select
                            <div style={{ position: 'relative' }} ref={dropdownRef}>

                                <div
                                    className={styles.addCatSelect}
                                    onClick={handleToggleDropdown}
                                >
                                    Select

                                </div>

                                {
                                    isOpen &&
                                    <div className={stylesp.dropdownContent}>
                                          <div style={{}}>
                                            <input
                                                type="text"
                                                placeholder="Search..."
                                                style={{
                                                    width: '100%',
                                                    padding: '10px',
                                                    boxSizing: 'border-box',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px'
                                                }}
                                                value={searchTerm}
                                                onChange={handleSearchChange}
                                            />
                                        </div>
                                        <div style={{ maxHeight: "140px", overflowY: "scroll" }}>
                                        {(filteredData || exportedData?.data)?.map((customer) => (
                                                <label
                                                    key={customer?._id}
                                                    className={stylesp.dropdownItem}
                                                >
                                                    {customer?.name}
                                                    <input
                                                        type="checkbox"
                                                        checked={values?.manufacturers?.includes(customer?._id)}
                                                        onChange={() => handleSelectionChange(customer?._id)}
                                                    />
                                                </label>
                                            ))}

                                        </div>
                                        <div style={{ display: 'flex', justifyContent: "center", width: "100%" }}>
                                            <button
                                                type="submit"
                                                className={stylesp.loginButton}
                                                style={{ borderRadius: "0px" }}
                                                onClick={() => setIsOpen(false)}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                }

                            </div>
                            {values?.manufacturers?.map((i) => {
                                const manufacturer = exportedData?.data?.find((item) => item?._id === i);
                                return (
                                    <div className={styles.dropdownresult}>
                                        {manufacturer?.name} <div onClick={() => handleSelectionChange(manufacturer._id)}><Closecircle /></div>
                                    </div>
                                )
                            })

                            }

                        </div>
                    </div>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>  Admin manager</h2>
                        <label style={{ paddingBottom: '10px', display: "block" }}>
                            Select Admin
                            <select
                                name="admin"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.admin}
                            >
                                <option value="">Select...</option>
                                {admin?.map((row) => (

                                    <option value={row?._id}>{row?.name}</option>
                                ))
                                }
                            </select>
                            {touched.admin && errors.admin && (
                                <div className={styles.errorText}>{errors.admin}</div>
                            )}
                        </label>
                    </div>
                </div>

            </form>
        </>
    );
};

export default EditVendorForm;











